import React from 'react'
import styled from 'styled-components'
import Popover from '@mui/material/Popover'
import Picker from './Picker'

const Value = styled.div`
    background: ${props => props.color};
    height: 30px;
    width: 30px;
    cursor: pointer;
    position: relative;
    outline: none;
    border-radius: ${props => props.type === 'square' ? '4px' : '50%'};
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
`

export default ({color, palette, type, handleChange}) => {
    // let sliderColor
    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        // if (type === 'swatches' && sliderColor) {
        //     handleChange(sliderColor)
        //     sliderColor = undefined
        // }

        setAnchorEl(null)
    }

    const onChange = (color) => {
        // if (type === 'swatches') {
            // sliderColor = color
        // } else {
            handleChange(color)
        // }
    }

    return (
        <React.Fragment>
            <Value color={color} onClick={handleOpen} type={type} />
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handleClose}
				PaperProps={{style:
					type === 'circle' ? {
						padding: '15px',
        				margin: '10px 0'
					} : {
						margin: '10px 0'
					}
				}}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Picker color={color}
                    palette={palette}
                    type={type}
                    onChange={onChange}
                />
            </Popover>
        </React.Fragment>
    )
}
